module.exports = __webpack_public_path__ + "static/media/articlecategories.2f353ca6.png";